import OutcomesTabs from "./OutcomesTabs";

export default OutcomesTabs;